// extracted by mini-css-extract-plugin
export default {"InfoBox":"InfoBox_InfoBox__GKa6E"};